/* eslint-disable multiline-ternary */
import React from 'react'
import resolveProps from '../../../utils/resolveProps'
import { CheckboxProps } from './types'


const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    }
  ],
  modifiers: ['inverse', 'darkest'],
  states: []
}

const Checkbox = (props:  CheckboxProps) => {
  const {
    id,
    parentId,
    className,
    parentClassName,
    name,
    value,
    checked = false,
    inverse,
    darkest,
    children,
    disabled,
    onChange = () => {},
    parentProps,
    hasError = false,
    errorMessage = 'Por favor, preencha este campo corretamente.',
    ...rest
  } = props


  const [isCheck, setIsCheck] = React.useState(checked)


  const _input = React.useRef(null)

  const [error, setError] = React.useState({
    message: errorMessage, // erroMessage
    hasError: hasError
  })

  React.useEffect(() => {
    setIsCheck(checked)
    _input.current.checked = checked
  }, [checked])

  React.useEffect(() => {
    setError({
      message: errorMessage, // erroMessage
      hasError: hasError
    })
  }, [hasError])

  const handleChange = (e) => {
    const status = !isCheck
    _input.current.checked = status

    setIsCheck(status)
    !!onChange && onChange(e)
  }

  const handleKeyPress = (e) => {
    if (e.charCode === 32 || e.charCode === 13) {
      handleChange(e)
    }
  }

  return (
    <div
      tabIndex={0}
      aria-label="checkbox"
      onKeyPress={(e) => handleKeyPress(e)}
      className={`${resolveProps(props, config, 'Checkbox')} ${
        parentClassName || ''
      }
        ${error.hasError ? 'mdn-Checkbox--attentionField' : ''}`}
      {...parentProps}
    >
      <input
        className="mdn-Checkbox-input"
        id={id}
        type="checkbox"
        ref={_input}
        onChange={(e) => handleChange(e)}
        disabled={disabled}
        {...rest}
      />
      <label className="mdn-Checkbox-label" htmlFor={id}></label>
      <label
        className="mdn-Checkbox-text"
        htmlFor={id}
      >
        {children}
      </label>

      {!error.hasError ? (
        ''
      ) : (
        <small className="mdn-Input-errorFeedback">{error.message}</small>
      )}
    </div>
  )
}

export default Checkbox
